export const downSampleBuffer = (
	{ buffer, sampleRate, targetSampleRate }: { buffer: Float32Array; sampleRate: number; targetSampleRate: number },
) => {
	if (targetSampleRate > sampleRate) {
		throw new Error(
			`targetSampleRate ${targetSampleRate} cannot exceed sampleRate ${sampleRate}`,
		);
	}

	const interval = sampleRate / targetSampleRate;
	const returnBuffer: number[] = [];

	for (let i = 0; i < buffer.length; i += interval) {
		returnBuffer.push(buffer[Math.floor(i)] as number);
	}

	return returnBuffer;
};
